import { ChangeDetectionStrategy, Component, computed, effect, inject, Signal } from '@angular/core';
import { ButtonComponent } from '@shared/components/atoms/button/button.component';
import { NewsFeedStore } from '@features/admin/store/news-feed.store';
import { ResponseStatus } from '@shared/models/base/response-status.model';
import { Newsfeed, NewsFeedRequestType } from '@features/admin/models/newsfeed.model';
import { NMFTAIconComponent } from '@shared/components/atoms/icon/icon.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'nmfta-news-feed-banner',
    imports: [ButtonComponent, NMFTAIconComponent, TranslatePipe],
    templateUrl: './news-feed-banner.component.html',
    styleUrl: './news-feed-banner.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsFeedBannerComponent {
  private readonly newsFeedStore = inject(NewsFeedStore);
  news$: Signal<Newsfeed[]> = this.newsFeedStore.activeBannerNews;
  responseStatus$ = this.newsFeedStore.responseStatus;
  isLoading$ = computed(() => {
    return this.responseStatus$() === ResponseStatus.LOADING;
  });

  isPaused = false;
  display$: Signal<boolean> = this.newsFeedStore.displayBanner;

  constructor() {
    this.newsFeedStore.loadNewsFeeds({ newsFeedRequestType: NewsFeedRequestType.Banner });

    effect(() => {
       this.isPaused = !this.newsFeedStore.displayBanner();
    });
  }

  pauseScroll() {
    this.isPaused = true;
  }

  resumeScroll() {
    this.isPaused = false;
  }

  hideBanner() {
    this.newsFeedStore.toggleDisplayBanner(false);
  }

  openLink(link: string) {
    window.open(link, '_blank');
  }
}
